import { useContext, useEffect, useState } from 'react';
import { RestauInfoContext } from '../../../home/RestauInfoContext';
import axios from 'axios';
import Config from '../../../config/Config';
import { cateringDashboardWidgets } from '../CateringSetting/Components/dashboardSettingsConstants';

const useCateringDashboard = () => {
    const [refreshToggle, setRefreshToggle] = useState(false);
    const { restauHook } = useContext(RestauInfoContext);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [dashboardWidgets, setDashboardWidgets] = useState([]);

    useEffect(() => {
        //debugger;
        if (!restauHook.restauId) return;
        const fetchData = async () => {
            try {
                setLoading(true);
                setErrorMsg('');
                const token = await window.customerApp
                    .auth()
                    .currentUser.getIdToken();
                let config = {
                    headers: {
                        token: token,
                        'Content-Type': 'application/json',
                    },
                };
                let reqBody = {
                    restauId: restauHook.restauId,
                };
                const response = await axios.post(
                    Config.fetchCateringDashboardSettings,
                    reqBody,
                    config
                );
                if (!response.data || response.data.status === false) {
                    throw new Error(
                        'Error from the server: ' + response.data
                            ? response.data.msg
                            : null
                    );
                }
                if (!response.data.dashboardSettings) {
                    setDashboardWidgets(
                        cateringDashboardWidgets.filter(
                            (x) => x.displayByDefault
                        )
                    );
                } else {
                    setDashboardWidgets(
                        response.data.dashboardSettings.selectedWidgets.map(
                            (x) => {
                                return cateringDashboardWidgets.filter(
                                    (y) => y.value === x
                                )[0];
                            }
                        )
                    );
                }
            } catch (error) {
                console.log('Failed to load widgets to display..', error);
                setErrorMsg('Failed to load widgets to display...');
                // setSnackbarMessage(
                //     'Issue retrieving events. Please contact support if the issue persists.'
                // );
                // setSnackbarOpen(true);
            }

            setLoading(false);
        };

        fetchData();
    }, [restauHook.restauId]);

    const dashboardSections = [
        {
            content: 'InqToReachOut',
            timeline: 'all',
            additionalField: 'Submission',
            additionalKey: 'submissionTimestamp',
        },
        {
            content: 'InqToFollowUp',
            timeline: 'all',
            additionalField: 'Follow up by',
            additionalKey: 'followupDueDate',
        },
        {
            content: 'UpcomingEvent',
            timeline: 'all',
            additionalField: 'Other',
            additionalKey: 'eventType',
        },
        {
            content: 'RecentPastEvent',
            timeline: 'all',
            additionalField: 'Other',
            additionalKey: 'eventType',
        },
        {
            content: 'VoidEvent',
            timeline: 'all',
            additionalField: null,
            additionalKey: null,
        },
    ];

    const prioritySubmission = (results) => {
        results = results.sort(
            (a, b) =>
                a.submissionTimestamp._seconds - b.submissionTimestamp._seconds
        );
        return results;
    };

    const priorityFollowup = (results) => {
        results = results.sort(
            (a, b) => a.followupDueDate._seconds - b.followupDueDate._seconds
        );
        return results;
    };

    const priorityConfirmed = (results) => {
        return results;
    };

    const priorityRecent = (results) => {
        results = results.reverse();
        return results;
    };

    return {
        dashboardWidgets,
        prioritySubmission,
        priorityFollowup,
        priorityConfirmed,
        priorityRecent,
        refreshToggle,
        setRefreshToggle,
        loading,
        setLoading,
        errorMsg,
    };
};

export default useCateringDashboard;
